import React, { useState, useEffect } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import helpers from "helpers/helpers"
import moment from "moment"
import numeral from "numeral"
import FullTable from "components/FullTable"
import Switch from "react-switch"

const InventoryLotTypeHealth = (props) => {
	let ret = []
	const [substantiallyOnly, setSubstantiallyOnly] = useState(false)

	const getTrProps = (state, rowInfo, instance) => {
		if (rowInfo) {
			let v = rowInfo.original
			let months = parseInt(v.remaining_months_4)
			if (months <= 5) {
				return { className: "!bg-red-300" }
			} else if (months >= 5 && months <= 9) {
				return { className: "!bg-red-200" }
			} else if (months >= 10 && months <= 12) {
				return { className: "!bg-orange-200" }
			} else if (months >= 13) {
				return { className: "statusColor--approved" }
			}
		}
		return {}
	}
	const Legend = () => {
		return (
			<ul className="legend__list flex-5">
				<li>
					<span className="bg-red-300" />
					Sellout &lt; 5 Months
				</li>
				<li>
					<span className="bg-red-200" />
					Sellout 5-9 Months
				</li>
				<li>
					<span className="bg-orange-200" />
					Sellout 9-12 Months
				</li>
				<li>
					<span className="bg-green-200" />
					Sellout 12+ Months
				</li>
			</ul>
		)
	}
	let columns = [
		{
			Header: "Community",
			accessor: "community",
			filterMethod: (f, r) => helpers.tableText(f, r, "community"),
		},
		{
			Header: "Lot Type",
			accessor: "lot_type",
			filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
		},
		{
			Header: "VDL Developer",
			accessor: "vdl_dev",
			Footer: (props) => helpers.tableTotals(props, "vdl_dev", "0,0"),
		},
		{
			Header: "VDL Builder",
			accessor: "vdl_builder",
			Footer: (props) => helpers.tableTotals(props, "vdl_builder", "0,0"),
		},
		{
			Header: "Net Sales Pace (Trailing 12)",
			accessor: "avg_monthly_sales_12",
			Footer: (props) => helpers.tableTotals(props, "avg_monthly_sales_12", "0,0.00"),
		},
		{
			Header: "Remaining Months (Trailing 12)",
			accessor: "remaining_months_12",
			Cell: (v) => {
				if (v.value !== null) return v.value
				return "N/A"
			},
			Footer: (props) => helpers.tableAverages(props, "remaining_months_12", "0,0.00"),
		},
		{
			Header: "Net Sales Pace (Trailing 4)",
			accessor: "avg_monthly_sales_4",
			Footer: (props) => helpers.tableTotals(props, "avg_monthly_sales_4", "0,0.00"),
		},
		{
			Header: "Remaining Months (Trailing 4)",
			accessor: "remaining_months_4",
			Cell: (v) => {
				if (v.value !== null) return v.value
				return "N/A"
			},
			Footer: (props) => helpers.tableAverages(props, "remaining_months_4", "0,0.00"),
		},
		{
			Header: "Momentum",
			accessor: "momentum",
			Cell: (v) => {
				if (v.value && Math.sign(v.value) == 1) {
					return <span className="darkGreen bold">{numeral(v.value).format("0,0.00")}%</span>
				} else if (v.value && Math.sign(v.value) == -1) {
					return <span className="red bold">{numeral(v.value).format("0,0.00")}%</span>
				}
				return "0%"
			},
		},
	]
	let model = {
		vdl_builder: 0,
		vdl_dev: 0,
		remaining_months_12: 0,
		remaining_months_4: 0,
		avg_monthly_sales_12: 0,
		avg_monthly_sales_4: 0,
		momentum: 0,
	}
	let store = []
	_.forEach(props.payload.exec.lots, (v) => {
		try {
			if (substantiallyOnly && !v.substantially_complete) return
			let com = _.find(props.payload.public.properties, { id: v.property })
			let lt = _.find(props.payload.public.lot_types, { id: v.lot_type })
			if (!com || !lt) throw `Cannot find required info for lotid ${v.id}`
			let look = { community: com.name, lot_type: lt.name }
			let find = _.find(store, look)
			if (!find) {
				store.push({
					community: com.name,
					lot_type: lt.name,
					lot_type_id: v.lot_type,
					..._.clone(model),
				})
			}
			let index = _.findIndex(store, look)
			if (index === -1) {
				throw `Can't find index.`
			}

			if (helpers.isBuilderVDL(v)) {
				store[index].vdl_builder++
			} else if (!v.takedown_date) {
				store[index].vdl_dev++
			}

		} catch (e) {
			console.error(e)
		}
	})

	//? Twelve month
	let oneYear = moment().subtract(1, "year").unix()
	_.forEach(store, (v) => {
		// Get sales for last twelve months
		let sales = _.filter(props.payload.exec.sales, (r) => {
			return r.lot_type == v.lot_type_id && r.sale_date >= oneYear
		})

		// Get cancellations for last twelve months
		let cancels = _.filter(props.payload.exec.busts, (r) => {
			return r.lot_type == v.lot_type_id && r.bustout_date >= oneYear
		})

		// Calculate net sales (sales minus cancellations)
		let netSales = sales.length - cancels.length

		// Find earliest sale date in range to calculate actual selling period
		let earliestSale = sales.length > 0 ? Math.min(...sales.map((s) => s.sale_date)) : moment().unix()

		// Calculate months from earliest sale to now
		let monthsActive = moment().diff(moment.unix(earliestSale), "months", true)
		monthsActive = Math.min(monthsActive, 12) // Cap at 12 months
		monthsActive = Math.max(monthsActive, 1) // Minimum 1 month to avoid division by zero

		// Calculate average monthly sales over actual selling period
		v.avg_monthly_sales_12 = parseFloat(numeral(netSales / monthsActive).format("0,0.00"))

		// Calculate remaining months of inventory
		let ops = (v.vdl_builder + v.vdl_dev) / v.avg_monthly_sales_12
		if (!isNaN(ops) && isFinite(ops)) {
			v.remaining_months_12 = parseFloat(numeral(ops).format("0,0.00"))
		} else {
			v.remaining_months_12 = null
		}
	})

	//? four months
	let fourMonths = moment().subtract(4, "months").unix()
	_.forEach(store, (v) => {
		// Get sales for last four months
		let sales = _.filter(props.payload.exec.sales, (r) => {
			return r.lot_type == v.lot_type_id && r.sale_date >= fourMonths
		})

		// Get cancellations for last four months
		let cancels = _.filter(props.payload.exec.busts, (r) => {
			return r.lot_type == v.lot_type_id && r.bustout_date >= fourMonths
		})

		// Calculate net sales (sales minus cancellations)
		let netSales = sales.length - cancels.length

		// Find earliest sale date in range to calculate actual selling period
		let earliestSale = sales.length > 0 ? Math.min(...sales.map((s) => s.sale_date)) : moment().unix()

		// Calculate months from earliest sale to now
		let monthsActive = moment().diff(moment.unix(earliestSale), "months", true)
		monthsActive = Math.min(monthsActive, 4) // Cap at 4 months
		monthsActive = Math.max(monthsActive, 1) // Minimum 1 month to avoid division by zero

		// Calculate average monthly sales over actual selling period
		v.avg_monthly_sales_4 = parseFloat(numeral(netSales / monthsActive).format("0,0.00"))

		// Calculate remaining months of inventory
		let ops = (v.vdl_builder + v.vdl_dev) / v.avg_monthly_sales_4
		if (!isNaN(ops) && isFinite(ops)) {
			v.remaining_months_4 = parseFloat(numeral(ops).format("0,0.00"))
		} else {
			v.remaining_months_4 = null
		}
	})
	_.forEach(store, (v) => {
		let calc = helpers.percentChange(v.avg_monthly_sales_12, v.avg_monthly_sales_4)
		v.momentum = calc || null

		ret.push({ ...v })
	})
	return (
		<>
			<h3>
				<span className="bug live">LIVE</span>Lot Type Health
			</h3>
			<Legend />
			<div className="switch" style={{ marginTop: 15 }} onClick={(e) => e.stopPropagation()}>
				<Switch
					onChange={() => setSubstantiallyOnly(!substantiallyOnly)}
					checked={substantiallyOnly}
					checkedIcon={false}
					uncheckedIcon={false}
					key={"switch"}
					id={"switch"}
				/>
				<p>Showing {substantiallyOnly ? "Delivered Only Sections" : "All Sections"}</p>
			</div>
			<FullTable
				data={ret}
				columns={columns}
				classNames={"small"}
				defaultPageSize={20}
				name="execSnapshot__lotTypeHealth"
				title="Lot Type Health"
				getTrProps={getTrProps}
			/>
		</>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(InventoryLotTypeHealth)
